export default "__VITE_ASSET__ClMSaiS0__"